import { Link } from "react-router";
import type { ChiefNoteDTO } from "@roomate/core";
import { chiefNoteLine, isInternalRef } from "../lib/chief-note.ts";

/** The Chief's note above a decision's options: the line, then its facts (packet links). Shown whenever a note exists. */
export function ChiefNote({ note, className = "" }: { note: ChiefNoteDTO | null | undefined; className?: string }) {
  if (!note) return null;
  const links = note.packetLinks ?? [];
  return (
    <div className={`rounded-2xl bg-ink/[0.04] px-4 py-3 text-[13px] text-ink-2 ${className}`} data-testid="chief-note">
      <p>{chiefNoteLine(note)}</p>
      {links.length > 0 && (
        <ul className="mt-1 space-y-0.5 text-ink-3">
          {links.map((l) => (
            <li key={`${l.ref}|${l.label}`}>
              {isInternalRef(l.ref) ? (
                <Link to={l.ref} className="underline decoration-rule hover:text-ink">
                  {l.label}
                </Link>
              ) : (
                <>
                  {l.label}: {l.ref}
                </>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
